/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { NotaryAPI } from '../api/notary/types';
import { notaryAPI } from '../api/notary';
import { addNotification } from '../actions/pageActions';
import { Dispatch } from '../redux';
import { NotificationItem } from '@components/common/Notifications/NotificationItem';
import { ActiveCallStatuses } from '@shared/constants/call';

export async function startCall(callId: string, dispatch: Dispatch): Promise<NotaryAPI.CallDetailsResponse> {
  const call = await notaryAPI.calls.startCall(callId);
  await collateCallDocuments(callId, dispatch);
  return call;
}

export async function startVideoRecording(callId: string): Promise<NotaryAPI.CallDetailsResponse> {
  const call = await notaryAPI.calls.startVideoRecording(callId);
  if (!call.notaryVideoAccessToken) {
    throw new Error('Response from notaryAPI.calls.startVideoRecording should include a notary video access token.');
  }
  return call;
}

async function collateCallDocuments(callId: string, dispatch: Dispatch): Promise<void> {
  try {
    await notaryAPI.calls.prepareSigningEnvelope(callId);
  } catch (e) {
    const notification: NotificationItem.PropsWithoutId = {
      type: 'error',
      iconType: 'error',
      content: 'Signing envelope creation failed.',
      shouldAutoRemove: true,
    };
    addNotification(notification)(dispatch);
  }
}

export async function hasVideoRecordingStarted(callId: string): Promise<boolean> {
  const callDetails = await notaryAPI.calls.fetchCall(callId);
  return !!callDetails.videoRoomId;
}

export async function hasCallStarted(callId: string): Promise<boolean> {
  const callDetails = await notaryAPI.calls.fetchCall(callId);
  return ActiveCallStatuses.includes(callDetails.status);
}
